import { isEastTerritory } from 'common/utils/checkTerritory';

export const WEST_MOBILITY_NAME = 'E100 Mobility';
export const EAST_MOBILITY_NAME = {
  ru: 'Онлайн-заправка',
  en: 'Mobile Refueling',
  pl: 'Tankowanie online',
  lt: 'Kuras internetu',
  es: 'Repostaje online',
  tr: 'Mobil yakıt',
  uk: 'Онлайн-заправка',
};

export const MOBILITY_NAME = (locale: keyof typeof EAST_MOBILITY_NAME) =>
  isEastTerritory
    ? EAST_MOBILITY_NAME[locale] || EAST_MOBILITY_NAME['en']
    : WEST_MOBILITY_NAME;
